import type { ReactNode } from 'react'
import { useEffect } from 'react'

import type { Messages } from '@lingui/core'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'

type Props = {
  children: ReactNode
  messages?: Messages
}

export const TestI18nProvider = ({ children, messages = {} }: Props) => {
  useEffect(() => {
    i18n.load('en', messages)
    i18n.activate('en')
  }, [messages])

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>
}
